import { AppConfigsService } from '@core/app-configs/services/app-configs.service';
import { AppFeaturesService } from '@core/app-features/services/app-features.service';
import { HealthService } from '@core/monitoring/services/health.service';
import { NavController } from '@ionic/angular/standalone';
import { defer, Observable, of } from 'rxjs';
import { concatMap, map, tap } from 'rxjs/operators';

export function appInitializerFactory(
    health: HealthService,
    appFeatures: AppFeaturesService,
    appConfigs: AppConfigsService,
    navController: NavController
): () => Observable<unknown> {
    return () =>
        health.checkApiServerStatus().pipe(
            tap((ok) => {
                if (!ok) {
                    void navController.navigateRoot('/service-unavailable', { replaceUrl: true });
                }
            }),
            concatMap((ok) => {
                if (!ok) return of(true);

                return defer(() => Promise.resolve(appFeatures.registerEnabledAppFeatures())).pipe(
                    concatMap(() => defer(() => Promise.resolve(appConfigs.registerAppConfigs()))),
                    map(() => true)
                );
            })
        );
}
